import ZHBMembership from "../board-memberships/ZHBMembership";
import ZHBEntries from "../docs-archive-elements/ZHBEntries";
export default function ZHBDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Zoning Hearing Board</h2>
        </div>

        {/*End Large Image Space*/}

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p">
            
              <h4>Meetings</h4>
              <ul>
                <li>7:00 p.m.</li>
                <li>1st Monday of the month</li>
                <li>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Borough
                    Hall
                    <br />
                    35 Union Street
                    <br />
                    Morrisville, PA 19067
                  </a>
                  <br />
                </li>
              </ul>
              <h4>Composition</h4>
                <ul>
                  <li>4 Members</li>
                  <li>3 year terms</li>
                  <li>Terms expire on the first Monday in January</li>
                </ul> 
              {/*Accordion Start*/}
              <div className="container accordion-container">
                <div className="accordion" id="ZHBPurposeAccordion">
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseZHBPurposeAccordion"
                      >
                        <div>
						<i className="fa-solid fa-scroll fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Purpose</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseZHBPurposeAccordion"
                      className="accordion-collapse collapse"
                      data-bs-parent="#ZHBPurposeAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          The zoning hearing board is a quasi-judicial body that
                          renders decisions on specific types of land use
                          appeals and applications. Members of the zoning
                          hearing board are appointed by the governing body.
                          Although the zoning hearing board functions like a
                          court, formal court procedures are not strictly
                          required.
                        </p>
                        <p>
                          The primary purpose of the zoning hearing board is to
                          help assure fair and equitable application and
                          administration of the zoning ordinance. The zoning
                          hearing board hears appeals from the zoning officer’s
                          determinations and grants relief from the literal
                          enforcement of the zoning ordinance in certain
                          hardship situations by means of a variance. The right
                          to appeal for relief is an important step in ensuring
                          that due process is followed when restricting use of
                          private property for a predetermined public good. The
                          zoning hearing board also hears applications for
                          special use and challenges to the substantive validity
                          of ordinances. The Pennsylvania Municipalities
                          Planning Code (MPC) provides a specific set of rules
                          that must be followed for applications submitted to
                          the zoning hearing board.
                        </p>
                        <p>
                          The zoning hearing board has no legislative power; it
                          can neither make nor modify zoning policy. Neither
                          does the zoning hearing board have enforcement powers.
                          The zoning hearing board schedules hearings on
                          applications and appeals that come before it, takes
                          evidence, and issues written decisions with findings
                          of fact and conclusions of law. A zoning hearing board
                          must limit its scope of activities to those permitted
                          by the MPC and by the local zoning ordinance. As such,
                          the zoning hearing board does not have statutory
                          powers in matters relating to the Uniform Construction
                          Code.
                        </p>
                        <p>
                          It is important that the zoning hearing board members
                          have a thorough knowledge not only of its specific
                          functions, but also of its place within the arena of
                          local planning decisions. While the zoning hearing
                          board is not responsible for the contents of the
                          zoning ordinance, it nevertheless plays a vital role
                          in the overall effectiveness of the zoning ordinance.
                          In addition, the zoning hearing board may detect
                          weaknesses in the zoning ordinance, perhaps as a
                          result of frequent and similar variance requests. When
                          a flaw, weakness, or lack of clarity is noticed, it
                          should be communicated to the zoning officer and
                          planning commission for their consideration to amend
                          the zoning ordinance accordingly.
                        </p>
                        <p>
                          The zoning hearing board has the power to assure the
                          fair and equitable application of the zoning
                          ordinance. Abuses of this power can, in effect,
                          undermine the zoning ordinance. An abuse or error of
                          law can lead to a decision of the zoning hearing board
                          being overturned on appeal.
                        </p>
                        <p>
                          Local officials should not take an appointment to the
                          zoning hearing board lightly, nor should an appointee.
                          It is an extremely responsible and demanding position,
                          one that will play an important role in the growth and
                          development of the community. Three (3) year term
                          expiring the first (1st) Monday in January.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                     {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBoardApply">
                        <div>
                          <i className="fa-solid fa-person-circle-plus fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Apply To Join The Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBoardApply" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
              
				  </div>
                    </div>
            {/*Accordion Finish*/}
			</div>

          <div className="mb-960-col-50p">
            <div className="council-members">
              <ZHBMembership/>
</div>
              <h4>Related Documents</h4>
              <ZHBEntries />
            </div>
          </div>
        
      </div>
      <div className="page-footer bottom-cap-outlines">&nbsp;</div>
      <div className="gap-spacer"></div>
    
</div>
	</div>
	
  );
}
